var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.2591H8.75005C7.12188 18.2591 6.3078 18.2591 5.64538 18.4601C4.1539 18.9125 2.98675 20.0796 2.53432 21.5711C2.33337 22.2335 2.33337 23.0476 2.33337 24.6758M16.9167 8.92578C16.9167 11.8253 14.5662 14.1758 11.6667 14.1758C8.76721 14.1758 6.41671 11.8253 6.41671 8.92578C6.41671 6.02629 8.76721 3.67578 11.6667 3.67578C14.5662 3.67578 16.9167 6.02629 16.9167 8.92578ZM12.8334 24.6758L16.4516 23.642C16.6249 23.5925 16.7115 23.5677 16.7923 23.5306C16.8641 23.4977 16.9323 23.4576 16.9959 23.4108C17.0676 23.3582 17.1313 23.2945 17.2587 23.1671L24.7918 15.6342C25.5972 14.8287 25.5972 13.5228 24.7917 12.7174C23.9863 11.912 22.6805 11.912 21.8751 12.7174L14.3421 20.2504C14.2146 20.3778 14.1509 20.4416 14.0983 20.5132C14.0516 20.5769 14.0115 20.6451 13.9785 20.7168C13.9414 20.7976 13.9167 20.8843 13.8672 21.0575L12.8334 24.6758Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4ff66cea3a643dd0ff659c07cfa34202.svg";
export { ForwardRef as ReactComponent };